import React from 'react'
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { BackButton } from '../../assets/svgs/svg';
import { useInAppBackNavigation } from '../../constants/customHooks'
import { IPageHeaderProps } from '../../constants/commonTypes';


const useStyles = makeStyles((_theme) => ({
  backBtn: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: '8%'
  },
}));

const PageHeader = (props: IPageHeaderProps) => {
  const { className } = props;
  const classes = useStyles();
  const goBack = useInAppBackNavigation()

  return (
    <div className={className}>
      <IconButton className={classes.backBtn} onClick={() => goBack()}>
        <BackButton width={30} height={20} />
      </IconButton>
    </div>
  )
}

export default PageHeader;